import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
  .information-component{
    margin: auto;
    max-width: ${toRem(1440)};
    background-color: ${theme.color['white']};
    padding: ${toRem(10)} 0 0;
    font-family: ${theme.fonts['fontFamilySwiss']};
    .component-heading{
      font-size: ${toRem(30)};
      margin-bottom: ${toRem(24)};
    }
    .component-content{
      display: flex;
      flex: 0;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    }
    .component-content>*{
      flex-basis: 100%;
      flex-grow: 0;
    }
    .component-content-small-screen{
      display: none;
    }
  }

  @media only ${theme.mediaQuery.smallerTablet} {
    .information-component{
      padding-top: ${toRem(33)};
      .component-heading{
        font-size: ${toRem(22)};
        margin-bottom: ${toRem(24)};
      }
      .component-content{
        display: none;
      }
      .component-content-small-screen{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        .right-content{
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
  @media only ${theme.mediaQuery.allMobiles} {
    .information-component{
      .component-heading{
        font-size: ${toRem(22)};
        margin-bottom: ${toRem(11)};
      }
      .component-content{
        display: flex;
        flex-direction: column;
      }
      .component-content-small-screen{
        display: none;
      }
    }
  }`}
`;
